import {
    faCalendar,
    faChalkboardTeacher,
    faFileInvoice,
    faMapPin,
    faStoreAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@ui';
import { useRouter } from 'next/router';
import React from 'react';
import { SearchTileProps } from '../SearchTile';
import { BaseTile } from './BaseTile';

interface Props extends SearchTileProps {}

export const ClubTile: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ item }: Props) => {
    const { push } = useRouter();

    return (
        <div className="tw-relative">
            <Badge className="tw-absolute -tw-right-2 -tw-top-2 tw-z-20" color="light" size="md">
                Verein
                <FontAwesomeIcon className="ml-2" icon={faStoreAlt} />
            </Badge>
            <BaseTile
                onPress={() => push(`/club/${item.slug}`)}
                title={item.title}
                headerImageId={item.header}
                imageId={item.logo}
            >
                <div className="tw-flex tw-flex-wrap tw-gap-2">
                    {item.offers?.space_bookings && (
                        <Badge color="light" className="tw-flex tw-items-center tw-gap-2 tw-py-1.5 tw-leading-3">
                            <FontAwesomeIcon icon={faMapPin} />
                            <small>
                                Platz-
                                <br />
                                Buchungen
                            </small>
                        </Badge>
                    )}
                    {item.offers?.events && (
                        <Badge color="light" className="tw-flex tw-items-center tw-gap-2 tw-py-1.5 tw-leading-3">
                            <FontAwesomeIcon icon={faCalendar} />
                            <small>Events</small>
                        </Badge>
                    )}
                    {item.offers?.trainer_bookings && (
                        <Badge color="light" className="tw-flex tw-items-center tw-gap-2 tw-py-1.5 tw-leading-3">
                            <FontAwesomeIcon icon={faChalkboardTeacher} />
                            <small>Trainerstunden</small>
                        </Badge>
                    )}
                    {item.offers?.online_application && (
                        <Badge color="light" className="tw-flex tw-items-center tw-gap-2 tw-py-1.5 tw-leading-3">
                            <FontAwesomeIcon icon={faFileInvoice} />
                            <small>
                                Online
                                <br />
                                Mitgliedsantrag
                            </small>
                        </Badge>
                    )}
                </div>
            </BaseTile>
        </div>
    );
};
